import React from "react";

import SrrRowBase from "./SrrRowBase";

const ReportNSByDealer = ({ row, bonus }) => {
  const lastItem = {
    soldCars: 0,
    soldCarsToNewClients: 0,
    percentNewClients: 0,
    soldCarsToLoyalClients: 0,
    soldCarsToLoyalClientsMoney: 0,
    percentLoyalClients: 0,
    twoCars: 0,
    percentTwoCars: 0,
    threeCars: 0,
    percentThreeCars: 0,
    fourOrMoreCars: 0,
    percentFourOrMoreCars: 0,
  };

  const arrBonus = bonus
    ? [row.bonusCarCount, row.bonusCarMoney, row.coefficientAward]
    : [];

  const isDealer = (elem) => (elem ? elem : "");

  const renderItem = [
    !!row.dealer && isDealer(row.dealer.DealerName),
    !!row.dealer && isDealer(row.dealer.city),
    !!row.dealer && isDealer(row.dealer.INN),
    !!row.dealer && isDealer(row.dealer.entfCode),
    !!row.dealer && isDealer(row.dealer.subject),
    !!row.dealer && isDealer(row.dealer.FO),
    !!row.dealer &&
    !!isDealer(row.dealer.status) &&
    row.dealer.status === "active"
      ? "1"
      : "0",
    ...row.periodsData
      .map((el) => {
        lastItem.soldCars += el.soldCars;
        lastItem.soldCarsToNewClients += el.soldCarsToNewClients;
        lastItem.percentNewClients += el.percentNewClients;
        lastItem.soldCarsToLoyalClients += el.soldCarsToLoyalClients;
        lastItem.soldCarsToLoyalClientsMoney += el.soldCarsToLoyalClientsMoney;
        lastItem.percentLoyalClients += el.percentLoyalClients;
        lastItem.twoCars += el.twoCars;
        lastItem.percentTwoCars += el.percentTwoCars;
        lastItem.threeCars += el.threeCars;
        lastItem.percentThreeCars += el.percentThreeCars;
        lastItem.fourOrMoreCars += el.fourOrMoreCars;
        lastItem.percentFourOrMoreCars += el.percentFourOrMoreCars;

        return [
          el.soldCars,
          el.soldCarsToNewClients,
          el.percentNewClients,
          el.soldCarsToLoyalClients,
          el.soldCarsToLoyalClientsMoney,
          el.percentLoyalClients,
          el.twoCars,
          el.percentTwoCars,
          el.threeCars,
          el.percentThreeCars,
          el.fourOrMoreCars,
          el.percentFourOrMoreCars,
        ];
      })
      .flat(),
    lastItem.soldCars,
    lastItem.soldCarsToNewClients,
    lastItem.percentNewClients,
    lastItem.soldCarsToLoyalClients,
    lastItem.soldCarsToLoyalClientsMoney,
    lastItem.percentLoyalClients,
    lastItem.twoCars,
    lastItem.percentTwoCars,
    lastItem.threeCars,
    lastItem.percentThreeCars,
    lastItem.fourOrMoreCars,
    lastItem.percentFourOrMoreCars,
    ...arrBonus,
  ];

  return <SrrRowBase cells={renderItem} />;
};

export default ReportNSByDealer;
